export default __webpack_public_path__ + "static/media/IMG_4586-min.592728b5.JPG";